export default {
    parameters: {
        landing_id: "TrITmn",
    },
    downtimeUrl: "https://cl.kodland.tech",
    startPage: {
      image: {
            url:  "/welcome/quiz_turkey_first_money_in_it_pk.png",
            style: {
              height: "100%",
              "max-height": "100vh",
            },
      },
      imageMobile: {
            url: "/welcome/quiz_turkey_first_money_in_it_mobile.png",
            style: {
              width: "100%",
            },
      },
      title: "Çocuğunuzu hemen IT uzmanı kariyerine başlatın.",
      subtitle: "5 soruya cevap verin, mentorumuzla bire-bir ders alın ve çocuğunuzun IT’de ilk parasını nasıl kazanacağını öğrenin.",
      button: "Ücretsiz almak için tıklayın",
    },
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
      1: {
        question: "Ücretsiz dersinizden kazanmak istediğiniz en önemli şeyler nelerdir?",
        answers: [
          "🖥 Geleceğe yönelik yararlı beceriler",
          "👍 Samimi ve keyifli bir deneyim",
          "🎓 Çocuğunuzun motivasyonunda bir artış",
          "😎 Kullanıcı dostu öğrenme platformumuz hakkında bilgi",
          "❓Bir soruyu atla",
        ],
      },
      2: {
        question: "Çocuğunuzun okulda en sevdiği ders hangisidir?",
        answers: [
          "🎨 Sanat ve tasarım",
          "💻 Bilgisayar bilimi",
          "📙 Tarih, Edebiyat",
          "📐 Matematik",
          "🤔 Emin değilim",
        ],
      },
      3: {
        question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
        answers: [
          {
            answer: "💻 Evet",
            distribution_tag_question: [18],
          },
          {
            answer: "😐 Hayır",
            stopAnswer: true
          },
        ],
      },
      4: {
        title: "Deneme dersi için hangi saatte uygunsunuz?",
        type: "timeslot",
        subtitle:
          "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
        button: "Rezervasyon için tıklayın 🎁",
      },
      5: {
        title: "Çocuğunuz kaç yaşında?",
        type: "age",
        subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
        button: "İleri 🚀",
      },
      6: {
        title: "Çocuğunuzun adı nedir?",
        type: "child_name",
        subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
        button: "İleri 🚀",
      },
      7: {
        title: "E-postanızı girin",
        type: "mail",
        subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
        button: "İleri 🚀",
      },
      8: {
        title: "Telefon numaranızı girin",
        type: "phone",
        subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
        button: "Neredeyse bitti 🔥",
      },
      9: {
        title: "İsminizi girin",
        type: "parent_name",
        subtitle: "Bizim adımız Kodland, sizinki ne?👋",
        button: "Son adım! 🎉",
      },
    },
  };
  
  
  